import { createPortal } from 'react-dom';
import Register from './Register';
import '../css/AdminRegisterModal.css';

function AdminRegisterModal({ groupId, onClose }) {
  return createPortal(
    <div className="admin-register-modal-backdrop" role="presentation" onMouseDown={event => {
      if (event.target === event.currentTarget) onClose();
    }}>
      <section className="admin-register-modal" role="dialog" aria-modal="true" aria-label="ลงทะเบียนสมาชิกเข้ากรุ๊ป">
        <header>
          <div><strong>➕ ลงทะเบียนสมาชิกเข้ากรุ๊ป</strong><small>Group #{groupId || '-'}</small></div>
          <button type="button" onClick={onClose} aria-label="ปิด">✕</button>
        </header>
        <div className="admin-register-modal-content">
          <Register embedded initialGroupId={groupId} onClose={onClose} />
        </div>
      </section>
    </div>,
    document.body
  );
}

export default AdminRegisterModal;
